import { useMutation } from "@apollo/client"
import React, { useCallback, useEffect, useState } from "react"
import { AddButton } from "./add_bundle_to_cart"
import { graphql } from "@/api"
import { basketAddToGA4 } from "@/common/util"
import { setBasketStateDoc } from "@/menu/components/basket_modal"

const basketAddDoc = graphql(`
  mutation ExampleBasketAdd(
    $signId: ID!
    $recommended: String
    $minimaticTextOne: String
    $minimaticTextTwo: String
    $minimaticTextThree: String
    $count: Int
    $examplerId: Int
    $signCategoryId: Int
  ) {
    exampleBasketAdd(
      signId: $signId
      recommended: $recommended
      minimaticTextOne: $minimaticTextOne
      minimaticTextTwo: $minimaticTextTwo
      minimaticTextThree: $minimaticTextThree
      count: $count
      examplerId: $examplerId
      signCategoryId: $signCategoryId
    ) {
      success
      landingUrl

      item {
        id
        priceSek
        totalCount
        hangType
        materialNameForGtm
        signTypeKey
        discountPercentage
        sizeDisplay
      }

      status {
        ...BasketModal_Order
      }
    }
  }
`)

export interface AddExampleToCartProps {
  signId: string
  recommended?: string
  secondaryNoIcon?: boolean
  dataGtm?: string
  minimaticTextOne?: string
  minimaticTextTwo?: string
  minimaticTextThree?: string
  count?: number
  examplerId: number
  signCategoryId?: number
}

const AddExampleToCart: React.FC<AddExampleToCartProps> = ({
  signId,
  recommended,
  dataGtm,
  secondaryNoIcon,
  minimaticTextOne,
  minimaticTextTwo,
  minimaticTextThree,
  count,
  examplerId,
  signCategoryId,
}) => {
  const [setBasketState] = useMutation(setBasketStateDoc)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  const openBasket = useCallback(() => {
    setBasketState({ variables: { open: true, addedNotice: true } })
  }, [setBasketState])

  const [addMutation, addMutationResult] = useMutation(basketAddDoc, {
    update: (store, { data: exampleBasketAddData }) => {
      if (exampleBasketAddData?.exampleBasketAdd?.success) {
        const orderItem = exampleBasketAddData.exampleBasketAdd.item

        basketAddToGA4(
          signId,
          orderItem.priceSek,
          count,
          orderItem.discountPercentage,
          orderItem.signTypeKey,
          orderItem.sizeDisplay,
          orderItem.hangType,
          orderItem.materialNameForGtm,
          exampleBasketAddData.exampleBasketAdd.landingUrl
        )
        openBasket()
      }
    },
  })

  const addBasket = () => {
    addMutation({
      variables: {
        signId,
        recommended,
        minimaticTextOne,
        minimaticTextTwo,
        minimaticTextThree,
        count: count || 1,
        examplerId,
        signCategoryId,
      },
    })
  }

  return (
    <AddButton
      loading={!loaded || addMutationResult.loading}
      onClick={addBasket}
      secondaryNoIcon={secondaryNoIcon}
      dataGtm={dataGtm}
    />
  )
}

export default AddExampleToCart
